export default __webpack_public_path__ + "static/media/rated.c9795b64.svg";